module.exports = __webpack_public_path__ + "img/popup_bg14.24cd8437.png";